import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import {
  setShowResetModalByDefault,
} from '../../slices/accounts';
import messages from './messages';
import ResetPasswordForm from '../forms/ResetPasswordForm';
import CreatePasswordForm from '../forms/CreatePasswordForm';
import ToastBanner from '../common/ToastBanner';
import styles from './ResetPasswordModal.module.scss';
import { CUSTOMERCARE_PHONE } from '../../utils/common/constants';

const ResetPasswordModal = ({
  setLoggedInCustomerId,
  mergeCart = true,
  showResetModal = false,
  customerEmail = '',
  redirectToAccountDashboard = false,
}) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const [resendEmail, setResendEmail] = useState('');
  const [aPIError, setAPIError] = useState(null);

  const { showLoginModal, isResendEmailSubmitted, showResetModalByDefault } = useSelector(
    (state) => state.accounts,
  );
  const [showLoginModalOnReset, setShowLoginModalOnReset] = useState(
    (!showLoginModal && !showResetModal),
  );

  useEffect(() => {
    dispatch(setShowResetModalByDefault({ showResetModalByDefault: showResetModal }));
  }, [dispatch, showResetModal]);

  useEffect(() => {
    if (showResetModal) {
      setShowLoginModalOnReset(false);
    }
  }, [showLoginModalOnReset, showResetModal]);

  useEffect(() => {
    if (isResendEmailSubmitted) {
      setResendEmail(isResendEmailSubmitted);
    }
  }, [isResendEmailSubmitted]);

  const closeToastBanner = () => {
    setAPIError(null);
  };

  return (
    <>
      {aPIError && (
        <ToastBanner
          type="error"
          onClickCloseButton={closeToastBanner}
        >
            { aPIError }
        </ToastBanner>
      )}
      {(!isResendEmailSubmitted && showResetModalByDefault) && (
        <div className={styles.resendContainer}>
          <h2 className={styles.modalHeader}>
            {formatMessage(messages.resetPasswordModalTitle)}
          </h2>
          <div>
            {formatMessage(messages.emailInputLabel)}
          </div>
          <ResetPasswordForm
            setAPIError={setAPIError}
            customerEmail={resendEmail || customerEmail}
          />
          <div className={styles.resendButton}>
            <div>{formatMessage(messages.customerCareHelp)}</div>
            <span>
              {formatMessage(messages.customerCareHelpText)}
            </span>
            <a
              className={styles['td-underline']}
              href={`tel:${CUSTOMERCARE_PHONE}`}
            >
              {CUSTOMERCARE_PHONE}
            </a>
          </div>
        </div>
      )}
      { (isResendEmailSubmitted && resendEmail) && (
        <CreatePasswordForm
          customerEmail={resendEmail}
          setLoggedInCustomerId={setLoggedInCustomerId}
          mergeCart={mergeCart}
          redirectToAccountDashboard={redirectToAccountDashboard}
        />
      )}
    </>
  );
};

ResetPasswordModal.propTypes = {
  setLoggedInCustomerId: PropTypes.func.isRequired,
  mergeCart: PropTypes.bool,
  showResetModal: PropTypes.bool,
  customerEmail: PropTypes.string,
  redirectToAccountDashboard: PropTypes.bool,
};

export default ResetPasswordModal;
